import { initCWElements } from '@cw-elements/config';
import { initMfes } from '@cw-elements/mfe-setup/init';
import * as ReactDOM from 'react-dom/client';

import AppContainer from './app.container';
import {
  CW_ELEMENTS_CONFIG,
  CW_ELEMENTS_ENV,
  CW_ELEMENTS_URL,
} from './cw-elements.config';

if (CW_ELEMENTS_ENV) {
  initCWElements(CW_ELEMENTS_CONFIG);
}

(async () => {
  await initMfes({
    'ag-operation': `${CW_ELEMENTS_URL}/ag-operation`,
    'entities-hall': `${CW_ELEMENTS_URL}/entities-hall`,
    'topbar-navigation': `${CW_ELEMENTS_URL}/topbar-navigation`,
  });
  await import('./main');
})();

// Amplitude and Datadog RUM are no longer initialized here: the analytics provider owns
// them, and it needs the LaunchDarkly rollback flag, which only resolves inside the React
// tree. See `useInitAnalytics`, called from `AppContainer`.
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(<AppContainer />);
